import React from 'react';
import { Reveal } from './showcase/Reveal';
export function QualificationBand() {
  return <section aria-label="Who this is built for" className="border-b border-white/5 bg-ink-900" data-id="element-218" data-mp="388u7r5trnu7">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-16" data-id="element-219" data-mp="i59l5sg6zerm">
        <Reveal data-id="element-220" data-mp="d66g4807p8jn">
          <p className="rounded-xl border border-brand/30 bg-brand/[0.07] px-6 py-5 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-221" data-mp="d5n9vojxc8lg">
            This is built for teams doing 50 or more sides a year that buy leads. If that
            is not you yet, we will cheer for you from here.
          </p>
        </Reveal>
      </div>
    </section>;
}